// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page {
  display: flex;
  gap: 50px;
  flex-direction: column;
  margin-top: 100px;
  position: relative;
}
.landing-page-hero-glow {
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 750px;
  height: 380px;
  background: radial-gradient(circle, rgba(71, 120, 245, 0.12) 0%, rgba(71, 120, 245, 0.03) 45%, rgba(255, 255, 255, 0) 70%);
  pointer-events: none;
  z-index: 0;
}
.landing-page-badge-pulse {
  width: 7px;
  height: 7px;
  background-color: #22c55e;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
  animation: pulseDot 1.8s infinite;
  margin-left: 4px;
  display: inline-block;
}
@keyframes pulseDot {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}
.landing-page-login-popup-container {
  position: fixed;
  top: 80px;
  right: 20px;
  width: 250px;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 999999;
  animation: fadeSlideIn 0.3s ease;
  overflow: hidden;
  border-radius: 5px;
}
.landing-page-login-popup-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
}
.landing-page-popup-left {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 17px;
  font-weight: 500;
  color: #2b2b2b;
}
.landing-page-popup-icon {
  width: 20px;
  height: 20px;
  background: #e53935;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
}
.landing-page-popup-close {
  font-size: 22px;
  cursor: pointer;
  color: #555;
  transition: 0.2s ease;
}
.landing-page-popup-close:hover {
  color: #000;
}
.landing-page {
  /* running line bar */
}
.landing-page-popup-progress {
  height: 6px;
  background: #e53935;
  transition: width 0.1s linear;
}
@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.landing-page-suggestions-dropdown {
  border: 1px solid var(--border-action-normal, #DEE0E3);
  max-height: 400px;
  overflow: auto;
  position: absolute;
  background: white;
  top: 20px;
  padding: 10px;
  width: 100%;
  z-index: 10;
  margin-top: 4px;
  border-radius: 6px;
  box-shadow: 0px 3px 6px -2px rgba(20, 21, 26, 0.0509803922);
}
.landing-page-suggestions-dropdown-loading {
  border: 1px solid var(--border-action-normal, #DEE0E3);
  max-height: 400px;
  overflow: auto;
  position: absolute;
  background: white;
  top: 20px;
  padding: 10px;
  width: 100%;
  z-index: 10;
  margin-top: 4px;
  border-radius: 6px;
  box-shadow: 0px 3px 6px -2px rgba(20, 21, 26, 0.0509803922);
  font-size: 14px;
  font-style: italic;
}
.landing-page-suggestions-item, .landing-page-suggestions-loading, .landing-page-suggestions-empty {
  background-color: rgba(10, 15, 41, 0.039);
  border-radius: 5px;
  color: #14151a;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 5px;
  overflow: hidden;
  padding: 0.5rem 0.75rem;
  text-overflow: ellipsis;
  transition: background-color 0.15s ease;
}
.landing-page .suggestions-item:hover {
  background-color: #e3eafd;
}
.landing-page-caselaw {
  display: flex;
  gap: 10px;
}
.landing-page-caselaw-petitioner {
  border: 1px solid var(--border-action-normal, #DEE0E3);
  border-radius: 11px;
  padding: 7px 20px;
  color: #14151A;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.landing-page-caselaw-petitioner:hover {
  border-color: #4778F5;
  background-color: #F4F7ff;
}
.landing-page-caselaw-petitioner-active {
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid #4778F5;
  color: #4778F5;
  background-color: #E3EAFD;
}
.landing-page-popular-searches {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 6px;
}
.landing-page-popular-searches .popular-label {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  margin-right: 4px;
}
.landing-page-popular-searches .popular-chip {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
}
.landing-page-popular-searches .popular-chip:hover {
  background: #e3eafd;
  color: #1d4ed8;
  border-color: #93c5fd;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(71, 120, 245, 0.15);
}
.landing-page-popular-searches .popular-chip:active {
  transform: scale(0.97);
}
.landing-page-stats-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  margin-top: 24px;
  padding: 16px 36px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  z-index: 1;
}
.landing-page-stats-bar .landing-page-stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s ease;
  cursor: default;
}
.landing-page-stats-bar .landing-page-stat-item:hover {
  transform: translateY(-2px);
}
.landing-page-stats-bar .landing-page-stat-item:hover .stat-number {
  color: #4778F5;
}
.landing-page-stats-bar .landing-page-stat-item .stat-number {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.5px;
  transition: color 0.2s ease;
}
.landing-page-stats-bar .landing-page-stat-item .stat-label {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  margin-top: 2px;
}
.landing-page-stats-bar .landing-page-stat-divider {
  width: 1px;
  height: 32px;
  background: #e2e8f0;
}
.landing-page-lower {
  background-color: #F8FAFC;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
}
.landing-page-lower-bottom {
  display: flex;
  justify-content: space-between;
  width: 80%;
}
.landing-page-lower-bottom-right {
  display: flex;
  gap: 40px;
}
.landing-page-lower-bottom-right-item-misc {
  display: flex;
  gap: 10px;
}
.landing-page-lower-bottom-right-item, .landing-page-lower-bottom-left {
  max-width: 250px;
}
.landing-page-lower-bottom-right-item-title, .landing-page-lower-bottom-left-title {
  font-size: 16px;
  font-weight: 700;
  color: #111111;
}
.landing-page-lower-bottom-right-item-description, .landing-page-lower-bottom-left-description {
  margin-top: 15px;
  font-size: 13px;
  font-weight: 400;
  color: #475569;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.landing-page-lower-bottom-right-item-description span, .landing-page-lower-bottom-left-description span {
  cursor: pointer;
  transition: color 0.15s ease;
}
.landing-page-lower-bottom-right-item-description span:hover, .landing-page-lower-bottom-left-description span:hover {
  color: #4778F5;
}
.landing-page-lower-separator {
  height: 1px;
  width: 80%;
  background-color: #CBD5E1;
}
.landing-page-lower-boxes {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.landing-page-lower-boxes .interactive-card {
  border: 1px solid #E2E8F0;
  background-color: white;
  padding: 20px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  border-radius: 16px;
  height: 165px;
  width: 240px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}
.landing-page-lower-boxes .interactive-card .card-icon-wrapper {
  width: 42px;
  height: 42px;
  background: #f0f5ff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease, background-color 0.3s ease;
}
.landing-page-lower-boxes .interactive-card .card-icon-wrapper img {
  width: 24px;
  height: 24px;
}
.landing-page-lower-boxes .interactive-card .card-explore-btn {
  font-size: 11px;
  font-weight: 600;
  color: #4778F5;
  opacity: 0;
  transform: translateY(4px);
  transition: all 0.2s ease;
}
.landing-page-lower-boxes .interactive-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 28px rgba(71, 120, 245, 0.12);
  border-color: #4778F5;
}
.landing-page-lower-boxes .interactive-card:hover .card-icon-wrapper {
  transform: scale(1.1) rotate(4deg);
  background: #e0ebff;
}
.landing-page-lower-boxes .interactive-card:hover .card-explore-btn {
  opacity: 1;
  transform: translateY(0);
}
.landing-page-lower-boxes .interactive-card-title {
  color: #111111;
  font-weight: 700;
  font-size: 15px;
  text-align: center;
}
.landing-page-lower-boxes .interactive-card-descritption {
  color: #64748B;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  width: 180px;
}
.landing-page-feature-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(5px);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}
.landing-page-feature-modal-content {
  background: white;
  width: 100%;
  max-width: 480px;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.18);
  position: relative;
  animation: slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
.landing-page-feature-modal-content .feature-modal-close {
  position: absolute;
  top: 18px;
  right: 18px;
  background: #f1f5f9;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: all 0.2s ease;
}
.landing-page-feature-modal-content .feature-modal-close:hover {
  background: #e2e8f0;
  color: #0f172a;
}
.landing-page-feature-modal-content .feature-modal-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}
.landing-page-feature-modal-content .feature-modal-header .feature-modal-icon-container {
  width: 50px;
  height: 50px;
  background: #eef2ff;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.landing-page-feature-modal-content .feature-modal-header .feature-modal-icon-container img {
  width: 26px;
  height: 26px;
}
.landing-page-feature-modal-content .feature-modal-header h3 {
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.landing-page-feature-modal-content .feature-modal-header .feature-modal-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}
.landing-page-feature-modal-content .feature-modal-description {
  font-size: 14px;
  line-height: 1.6;
  color: #334155;
  margin-bottom: 20px;
}
.landing-page-feature-modal-content .feature-modal-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.landing-page-feature-modal-content .feature-modal-highlights .highlight-pill {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #166534;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.landing-page-upper {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 50px;
  z-index: 1;
}
.landing-page-upper-subtitle {
  display: flex;
  font-size: 13px;
  font-weight: 600;
  color: #133A9A;
  border-radius: 20px;
  background-color: #E3EAFD;
  border: 1px solid #cbdcfd;
  padding: 7px 16px;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.5px;
}
.landing-page-upper-container {
  border: 1.5px solid #DEE0E3;
  box-shadow: 0px 8px 30px rgba(71, 120, 245, 0.08), 0px 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 24px;
  width: 70vw;
  padding: 14px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.landing-page-upper-container:focus-within {
  border-color: #4778F5;
  box-shadow: 0px 10px 36px rgba(71, 120, 245, 0.16), 0 0 0 3px rgba(71, 120, 245, 0.12);
}
.landing-page-upper-container-dropdown {
  border: 1px solid var(--border-action-normal, #DEE0E3);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  padding: 10px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 999;
  background-color: white;
  cursor: pointer;
  min-width: 85%;
  width: 150px;
  top: 48px;
  animation: fadeSlideIn 0.15s ease;
}
.landing-page-upper-container-dropdown-item {
  color: #14151A;
  font-size: 14px;
  font-weight: 400;
  padding: 8px 10px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}
.landing-page-upper-container-dropdown-item:hover {
  background-color: #F0F5FF;
  color: #4778F5;
  font-weight: 500;
}
.landing-page-upper-container-field {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  width: 80%;
}
.landing-page-upper-container-field .keyboard-shortcut-hint {
  display: flex;
  align-items: center;
  position: absolute;
  right: 14px;
  pointer-events: none;
}
.landing-page-upper-container-field .keyboard-shortcut-hint kbd {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 11px;
  font-family: inherit;
  font-weight: 600;
  color: #64748b;
}
.landing-page-upper-container-field input {
  background-color: transparent !important;
  border: none !important;
}
.landing-page-upper-container-field-act {
  width: 77%;
  padding: 10px;
  display: flex;
  gap: 20px;
}
.landing-page-upper-container-field-act-title {
  box-shadow: 0px 1px 2px 0px rgba(20, 21, 26, 0.0509803922);
  border: 1px solid var(--border-action-normal, #DEE0E3);
  padding: 7px;
  width: 70%;
  border-radius: 14px;
}
.landing-page-upper-container-field-act-title input {
  background-color: transparent !important;
  border: none !important;
}
.landing-page-upper-container-field-act-provision {
  box-shadow: 0px 1px 2px 0px rgba(20, 21, 26, 0.0509803922);
  border: 1px solid var(--border-action-normal, #DEE0E3);
  padding: 7px;
  width: 30%;
  border-radius: 14px;
}
.landing-page-upper-container-field-act-provision input {
  background-color: transparent !important;
  border: none !important;
}
.landing-page-upper-container-field-button {
  background: linear-gradient(135deg, #4778F5 0%, #2563EB 100%);
  box-shadow: 0px 4px 12px rgba(71, 120, 245, 0.3);
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 20px;
  cursor: pointer;
  border: 0px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.landing-page-upper-container-field-button:hover {
  transform: translateY(-1px);
  box-shadow: 0px 6px 16px rgba(71, 120, 245, 0.4);
  background: linear-gradient(135deg, #3b6ef0 0%, #1d4ed8 100%);
}
.landing-page-upper-container-field-button:active {
  transform: scale(0.98);
}
.landing-page-upper-container-field-bottom-container {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
}
.landing-page-upper-container-field input {
  width: 90%;
  border: none;
  font-size: 16px;
  color: #14151A;
  background-color: transparent;
  border: none !important;
}
.landing-page-upper-container-field input::placeholder {
  color: rgba(13, 17, 38, 0.4);
  font-size: 16px;
  font-weight: 400;
}
.landing-page-upper-container-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.landing-page-upper-container-buttons-right {
  border: 1px solid var(--border-action-normal, #DEE0E3);
  border-radius: 30px;
  box-shadow: 0px 1px 2px 0px rgba(20, 21, 26, 0.0509803922);
  font-size: 14px;
  font-weight: 500;
  color: #14151A;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  min-width: 90px;
  cursor: pointer;
  gap: 10px;
  transition: background-color 0.15s ease;
}
.landing-page-upper-container-buttons-right:hover {
  background-color: #F8FAFC;
}
.landing-page-upper-container-buttons-right input {
  border: none;
  border: none !important;
}
.landing-page-upper-container-buttons-left {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #14151A;
}
.landing-page-upper-container-buttons-left-tab {
  cursor: pointer;
  padding-bottom: 6px;
  color: rgba(15, 19, 36, 0.6);
  font-size: 16px;
  font-weight: 500;
  transition: color 0.15s ease;
}
.landing-page-upper-container-buttons-left-tab:hover {
  color: #4778F5;
}
.landing-page-upper-container-buttons-left-active {
  border-bottom: 2.5px solid #4778F5;
  color: #4778F5;
  font-size: 16px;
  font-weight: 600;
}
.landing-page-upper-description {
  font-size: 18px;
  font-weight: 500;
  color: #475569;
  max-width: 600px;
  text-align: center;
}
.landing-page-upper-title {
  font-size: 48px;
  font-weight: 800;
  color: #0f172a;
  text-align: center;
  letter-spacing: -1px;
}
.landing-page-upper-title .title-gradient {
  background: linear-gradient(135deg, #1d4ed8 0%, #4778f5 50%, #6366f1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

input:focus {
  border: none !important;
  outline: none;
}

* {
  box-sizing: border-box;
}

body {
  line-height: 1.42857143;
}

@media (max-width: 1035px) {
  #landing-page-lower-boxes {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  .landing-page-stats-bar {
    gap: 16px;
    padding: 12px 20px;
  }
  .landing-page-stats-bar .stat-number {
    font-size: 18px !important;
  }
}
/* Mobile (1 column) */
@media (max-width: 600px) {
  #landing-page-lower-boxes {
    display: grid !important;
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .landing-page-lower-bottom-right {
    display: grid !important;
    grid-template-columns: 1fr;
  }
  .landing-page-upper-title {
    font-size: 28px;
  }
  .landing-page-upper-description {
    font-size: 15px;
    text-align: center;
  }
  .landing-page-upper-container {
    width: 90vw !important;
  }
  .landing-page-upper {
    margin-top: 0px !important;
  }
  .landing-page-suggestions-dropdown {
    width: 200px !important;
  }
  .landing-page-stats-bar {
    flex-direction: column;
    gap: 12px;
    width: 90vw;
  }
  .landing-page-stats-bar .landing-page-stat-divider {
    width: 100%;
    height: 1px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LandingPage/Landing.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AACI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,0HAAA;EACA,oBAAA;EACA,UAAA;AACR;AAEI;EACI,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;AAAR;AAGI;EACI;IACI,sBAAA;IACA,0CAAA;EADV;EAGM;IACI,mBAAA;IACA,0CAAA;EADV;EAGM;IACI,sBAAA;IACA,wCAAA;EADV;AACF;AAII;EACI,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0CAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AAFR;AAKI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAHR;AAMI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAJR;AAOI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AALR;AAQI;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AANR;AASI;EACI,WAAA;AAPR;AAxFA;EAkGI,qBAAA;AAPJ;AAQI;EACI,WAAA;EACA,mBAAA;EACA,6BAAA;AANR;AASI;EACI;IACI,UAAA;IACA,4BAAA;EAPV;EAUM;IACI,UAAA;IACA,wBAAA;EARV;AACF;AAYI;EACI,sDAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,2DAAA;AAVR;AAYQ;EACI,sDAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,2DAAA;EACA,eAAA;EACA,kBAAA;AAVZ;AAcI;EAGI,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uCAAA;AAdR;AAiBI;EACI,yBAAA;AAfR;AAmBI;EACI,aAAA;EACA,SAAA;AAjBR;AAmBQ;EACI,sDAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAjBZ;AAmBY;EACI,qBAAA;EACA,yBAAA;AAjBhB;AAoBY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;AAlBhB;AAuBI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AArBR;AAuBQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AArBZ;AAwBQ;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iDAAA;EACA,oBAAA;EACA,mBAAA;AAtBZ;AAwBY;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;EACA,8CAAA;AAtBhB;AAyBY;EACI,sBAAA;AAvBhB;AA4BI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,UAAA;AA1BR;AA4BQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AA1BZ;AA4BY;EACI,2BAAA;AA1BhB;AA2BgB;EACI,cAAA;AAzBpB;AA6BY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;AA3BhB;AA8BY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA5BhB;AAgCQ;EACI,UAAA;EACA,YAAA;EACA,mBAAA;AA9BZ;AAkCI;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAhCR;AAkCQ;EACI,aAAA;EACA,8BAAA;EACA,UAAA;AAhCZ;AAkCY;EACI,aAAA;EACA,SAAA;AAhChB;AAmCoB;EACI,aAAA;EACA,SAAA;AAjCxB;AAsCY;EAEI,gBAAA;AArChB;AAuCgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AArCpB;AAwCgB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAtCpB;AAwCoB;EACI,eAAA;EACA,4BAAA;AAtCxB;AAwCwB;EACI,cAAA;AAtC5B;AA6CQ;EACI,WAAA;EACA,UAAA;EACA,yBAAA;AA3CZ;AA8CQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AA5CZ;AA8CY;EACI,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,yCAAA;AA5ChB;AA8CgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2DAAA;AA5CpB;AA8CoB;EACI,WAAA;EACA,YAAA;AA5CxB;AAgDgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,0BAAA;EACA,yBAAA;AA9CpB;AAiDgB;EACI,2BAAA;EACA,gDAAA;EACA,qBAAA;AA/CpB;AAiDoB;EACI,kCAAA;EACA,mBAAA;AA/CxB;AAkDoB;EACI,UAAA;EACA,wBAAA;AAhDxB;AAoDgB;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAlDpB;AAqDgB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAnDpB;AAyDI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;AAvDR;AA0DI;EACI,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;EACA,sDAAA;AAxDR;AA0DQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;AAxDZ;AA0DY;EACI,mBAAA;EACA,cAAA;AAxDhB;AA4DQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA1DZ;AA4DY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1DhB;AA4DgB;EACI,WAAA;EACA,YAAA;AA1DpB;AA8DY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA5DhB;AA+DY;EACI,eAAA;EACA,cAAA;EACA,eAAA;AA7DhB;AAiEQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA/DZ;AAkEQ;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAhEZ;AAkEY;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAhEhB;AAqEI;EACI;IAAO,UAAA;EAlEb;EAmEM;IAAK,UAAA;EAhEX;AACF;AAkEI;EACI;IAAO,UAAA;IAAY,2BAAA;EA9DzB;EA+DM;IAAK,UAAA;IAAY,wBAAA;EA3DvB;AACF;AA6DI;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;AA3DR;AA6DQ;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;AA3DZ;AA8DQ;EACI,2BAAA;EACA,kFAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wDAAA;AA5DZ;AA8DY;EACI,qBAAA;EACA,sFAAA;AA5DhB;AA+DY;EACI,sDAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;AA7DhB;AA+DgB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uCAAA;AA7DpB;AA+DoB;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;AA7DxB;AAkEY;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;AAhEhB;AAkEgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;AAhEpB;AAkEoB;EACI,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AAhExB;AAoEgB;EACI,wCAAA;EACA,uBAAA;AAlEpB;AAqEgB;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AAnEpB;AAqEoB;EACI,0DAAA;EACA,sDAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AAnExB;AAqEwB;EACI,wCAAA;EACA,uBAAA;AAnE5B;AAuEoB;EACI,0DAAA;EACA,sDAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AArExB;AAuEwB;EACI,wCAAA;EACA,uBAAA;AArE5B;AA0EgB;EACI,6DAAA;EACA,gDAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,iDAAA;AAxEpB;AA0EoB;EACI,2BAAA;EACA,gDAAA;EACA,6DAAA;AAxExB;AA2EoB;EACI,sBAAA;AAzExB;AA6EgB;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;AA3EpB;AA8EgB;EACI,UAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;EACA,uBAAA;AA5EpB;AA8EoB;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;AA5ExB;AAmFY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAjFhB;AAmFgB;EACI,sDAAA;EACA,mBAAA;EACA,0DAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;EACA,uCAAA;AAjFpB;AAmFoB;EACI,yBAAA;AAjFxB;AAoFoB;EACI,YAAA;EACA,uBAAA;AAlFxB;AAuFgB;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AArFpB;AAuFoB;EACI,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AArFxB;AAuFwB;EACI,cAAA;AArF5B;AAyFoB;EACI,kCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvFxB;AA6FQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA3FZ;AA8FQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AA5FZ;AA8FY;EACI,0EAAA;EACA,6BAAA;EACA,oCAAA;AA5FhB;;AAmGI;EACI,uBAAA;EACA,aAAA;AAhGR;;AAoGA;EACI,sBAAA;AAjGJ;;AAoGA;EACI,uBAAA;AAjGJ;;AAoGA;EACI;IACI,wBAAA;IACA,qCAAA;IACA,SAAA;EAjGN;EAmGE;IACI,SAAA;IACA,kBAAA;EAjGN;EAmGM;IACI,0BAAA;EAjGV;AACF;AAqGA,sBAAA;AACA;EACI;IACI,wBAAA;IACA,0BAAA;IACA,SAAA;EAnGN;EAqGE;IACI,wBAAA;IACA,0BAAA;EAnGN;EAqGE;IACI,eAAA;EAnGN;EAqGE;IACI,eAAA;IACA,kBAAA;EAnGN;EAqGE;IACI,sBAAA;EAnGN;EAqGE;IACI,0BAAA;EAnGN;EAqGE;IACI,uBAAA;EAnGN;EAqGE;IACI,sBAAA;IACA,SAAA;IACA,WAAA;EAnGN;EAqGM;IACI,WAAA;IACA,WAAA;EAnGV;AACF","sourcesContent":[".landing-page {\n    display: flex;\n    gap: 50px;\n    flex-direction: column;\n    margin-top: 100px;\n    position: relative;\n\n    &-hero-glow {\n        position: absolute;\n        top: -60px;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 750px;\n        height: 380px;\n        background: radial-gradient(circle, rgba(71, 120, 245, 0.12) 0%, rgba(71, 120, 245, 0.03) 45%, rgba(255, 255, 255, 0) 70%);\n        pointer-events: none;\n        z-index: 0;\n    }\n\n    &-badge-pulse {\n        width: 7px;\n        height: 7px;\n        background-color: #22c55e;\n        border-radius: 50%;\n        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);\n        animation: pulseDot 1.8s infinite;\n        margin-left: 4px;\n        display: inline-block;\n    }\n\n    @keyframes pulseDot {\n        0% {\n            transform: scale(0.95);\n            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);\n        }\n        70% {\n            transform: scale(1);\n            box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);\n        }\n        100% {\n            transform: scale(0.95);\n            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);\n        }\n    }\n\n    &-login-popup-container {\n        position: fixed;\n        top: 80px;\n        right: 20px;\n        width: 250px;\n        background: white;\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n        z-index: 999999;\n        animation: fadeSlideIn 0.3s ease;\n        overflow: hidden;\n        border-radius: 5px;\n    }\n\n    &-login-popup-content {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 16px 18px;\n    }\n\n    &-popup-left {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        font-size: 17px;\n        font-weight: 500;\n        color: #2b2b2b;\n    }\n\n    &-popup-icon {\n        width: 20px;\n        height: 20px;\n        background: #e53935;\n        color: white;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 16px;\n        font-weight: bold;\n    }\n\n    &-popup-close {\n        font-size: 22px;\n        cursor: pointer;\n        color: #555;\n        transition: 0.2s ease;\n    }\n\n    &-popup-close:hover {\n        color: #000;\n    }\n\n    /* running line bar */\n    &-popup-progress {\n        height: 6px;\n        background: #e53935;\n        transition: width 0.1s linear;\n    }\n\n    @keyframes fadeSlideIn {\n        from {\n            opacity: 0;\n            transform: translateY(-10px);\n        }\n\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n\n    &-suggestions-dropdown {\n        border: 1px solid var(--border-action-normal, #DEE0E3);\n        max-height: 400px;\n        overflow: auto;\n        position: absolute;\n        background: white;\n        top: 20px;\n        padding: 10px;\n        width: 100%;\n        z-index: 10;\n        margin-top: 4px;\n        border-radius: 6px;\n        box-shadow: 0px 3px 6px -2px #14151A0D;\n\n        &-loading {\n            border: 1px solid var(--border-action-normal, #DEE0E3);\n            max-height: 400px;\n            overflow: auto;\n            position: absolute;\n            background: white;\n            top: 20px;\n            padding: 10px;\n            width: 100%;\n            z-index: 10;\n            margin-top: 4px;\n            border-radius: 6px;\n            box-shadow: 0px 3px 6px -2px #14151A0D;\n            font-size: 14px;\n            font-style: italic;\n        }\n    }\n\n    &-suggestions-item,\n    &-suggestions-loading,\n    &-suggestions-empty {\n        background-color: rgba(10, 15, 41, .039);\n        border-radius: 5px;\n        color: #14151a;\n        cursor: pointer;\n        font-size: 14px;\n        font-weight: 400;\n        margin-bottom: 5px;\n        overflow: hidden;\n        padding: .5rem .75rem;\n        text-overflow: ellipsis;\n        transition: background-color 0.15s ease;\n    }\n\n    .suggestions-item:hover {\n        background-color: #e3eafd;\n    }\n\n\n    &-caselaw {\n        display: flex;\n        gap: 10px;\n\n        &-petitioner {\n            border: 1px solid var(--border-action-normal, #DEE0E3);\n            border-radius: 11px;\n            padding: 7px 20px;\n            color: #14151A;\n            font-size: 14px;\n            font-weight: 500;\n            cursor: pointer;\n            transition: all 0.2s ease;\n\n            &:hover {\n                border-color: #4778F5;\n                background-color: #F4F7ff;\n            }\n\n            &-active {\n                font-size: 14px;\n                font-weight: 500;\n                cursor: pointer;\n                border: 1px solid #4778F5;\n                color: #4778F5;\n                background-color: #E3EAFD;\n            }\n        }\n    }\n\n    &-popular-searches {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 8px;\n        padding: 4px 6px;\n\n        .popular-label {\n            font-size: 13px;\n            font-weight: 600;\n            color: #64748b;\n            margin-right: 4px;\n        }\n\n        .popular-chip {\n            background: #f1f5f9;\n            border: 1px solid #e2e8f0;\n            border-radius: 20px;\n            padding: 4px 12px;\n            font-size: 12px;\n            font-weight: 500;\n            color: #334155;\n            cursor: pointer;\n            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n            display: inline-flex;\n            align-items: center;\n\n            &:hover {\n                background: #e3eafd;\n                color: #1d4ed8;\n                border-color: #93c5fd;\n                transform: translateY(-1px);\n                box-shadow: 0 2px 6px rgba(71, 120, 245, 0.15);\n            }\n\n            &:active {\n                transform: scale(0.97);\n            }\n        }\n    }\n\n    &-stats-bar {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 32px;\n        margin-top: 24px;\n        padding: 16px 36px;\n        background: rgba(255, 255, 255, 0.85);\n        backdrop-filter: blur(12px);\n        border: 1px solid #e2e8f0;\n        border-radius: 18px;\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);\n        z-index: 1;\n\n        .landing-page-stat-item {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            transition: transform 0.2s ease;\n            cursor: default;\n\n            &:hover {\n                transform: translateY(-2px);\n                .stat-number {\n                    color: #4778F5;\n                }\n            }\n\n            .stat-number {\n                font-size: 22px;\n                font-weight: 800;\n                color: #0f172a;\n                letter-spacing: -0.5px;\n                transition: color 0.2s ease;\n            }\n\n            .stat-label {\n                font-size: 12px;\n                font-weight: 500;\n                color: #64748b;\n                margin-top: 2px;\n            }\n        }\n\n        .landing-page-stat-divider {\n            width: 1px;\n            height: 32px;\n            background: #e2e8f0;\n        }\n    }\n\n    &-lower {\n        background-color: #F8FAFC;\n        padding: 40px 20px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 40px;\n\n        &-bottom {\n            display: flex;\n            justify-content: space-between;\n            width: 80%;\n\n            &-right {\n                display: flex;\n                gap: 40px;\n\n                &-item {\n                    &-misc {\n                        display: flex;\n                        gap: 10px;\n                    }\n                }\n            }\n\n            &-right-item,\n            &-left {\n                max-width: 250px;\n\n                &-title {\n                    font-size: 16px;\n                    font-weight: 700;\n                    color: #111111;\n                }\n\n                &-description {\n                    margin-top: 15px;\n                    font-size: 13px;\n                    font-weight: 400;\n                    color: #475569;\n                    display: flex;\n                    flex-direction: column;\n                    gap: 8px;\n\n                    span {\n                        cursor: pointer;\n                        transition: color 0.15s ease;\n\n                        &:hover {\n                            color: #4778F5;\n                        }\n                    }\n                }\n            }\n        }\n\n        &-separator {\n            height: 1px;\n            width: 80%;\n            background-color: #CBD5E1;\n        }\n\n        &-boxes {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 20px;\n\n            .interactive-card {\n                border: 1px solid #E2E8F0;\n                background-color: white;\n                padding: 20px 16px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                flex-direction: column;\n                gap: 10px;\n                border-radius: 16px;\n                height: 165px;\n                width: 240px;\n                background: #ffffff;\n                cursor: pointer;\n                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n                position: relative;\n                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\n\n                .card-icon-wrapper {\n                    width: 42px;\n                    height: 42px;\n                    background: #f0f5ff;\n                    border-radius: 12px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    transition: transform 0.3s ease, background-color 0.3s ease;\n\n                    img {\n                        width: 24px;\n                        height: 24px;\n                    }\n                }\n\n                .card-explore-btn {\n                    font-size: 11px;\n                    font-weight: 600;\n                    color: #4778F5;\n                    opacity: 0;\n                    transform: translateY(4px);\n                    transition: all 0.2s ease;\n                }\n\n                &:hover {\n                    transform: translateY(-6px);\n                    box-shadow: 0 12px 28px rgba(71, 120, 245, 0.12);\n                    border-color: #4778F5;\n\n                    .card-icon-wrapper {\n                        transform: scale(1.1) rotate(4deg);\n                        background: #e0ebff;\n                    }\n\n                    .card-explore-btn {\n                        opacity: 1;\n                        transform: translateY(0);\n                    }\n                }\n\n                &-title {\n                    color: #111111;\n                    font-weight: 700;\n                    font-size: 15px;\n                    text-align: center;\n                }\n\n                &-descritption {\n                    color: #64748B;\n                    font-size: 12px;\n                    font-weight: 400;\n                    text-align: center;\n                    width: 180px;\n                }\n            }\n        }\n    }\n\n    &-feature-modal-backdrop {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(15, 23, 42, 0.45);\n        backdrop-filter: blur(5px);\n        z-index: 999999;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 20px;\n        animation: fadeIn 0.2s ease;\n    }\n\n    &-feature-modal-content {\n        background: white;\n        width: 100%;\n        max-width: 480px;\n        border-radius: 20px;\n        padding: 28px;\n        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.18);\n        position: relative;\n        animation: slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n\n        .feature-modal-close {\n            position: absolute;\n            top: 18px;\n            right: 18px;\n            background: #f1f5f9;\n            border: none;\n            width: 32px;\n            height: 32px;\n            border-radius: 50%;\n            font-size: 18px;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: #64748b;\n            transition: all 0.2s ease;\n\n            &:hover {\n                background: #e2e8f0;\n                color: #0f172a;\n            }\n        }\n\n        .feature-modal-header {\n            display: flex;\n            align-items: center;\n            gap: 16px;\n            margin-bottom: 16px;\n\n            .feature-modal-icon-container {\n                width: 50px;\n                height: 50px;\n                background: #eef2ff;\n                border-radius: 14px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n\n                img {\n                    width: 26px;\n                    height: 26px;\n                }\n            }\n\n            h3 {\n                font-size: 19px;\n                font-weight: 700;\n                color: #0f172a;\n                margin: 0;\n            }\n\n            .feature-modal-subtitle {\n                font-size: 13px;\n                color: #64748b;\n                margin-top: 2px;\n            }\n        }\n\n        .feature-modal-description {\n            font-size: 14px;\n            line-height: 1.6;\n            color: #334155;\n            margin-bottom: 20px;\n        }\n\n        .feature-modal-highlights {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n\n            .highlight-pill {\n                background: #f0fdf4;\n                border: 1px solid #bbf7d0;\n                color: #166534;\n                padding: 6px 12px;\n                border-radius: 8px;\n                font-size: 12px;\n                font-weight: 600;\n            }\n        }\n    }\n\n    @keyframes fadeIn {\n        from { opacity: 0; }\n        to { opacity: 1; }\n    }\n\n    @keyframes slideUp {\n        from { opacity: 0; transform: translateY(20px); }\n        to { opacity: 1; transform: translateY(0); }\n    }\n\n    &-upper {\n        display: flex;\n        flex-direction: column;\n        align-content: center;\n        align-items: center;\n        gap: 20px;\n        margin-top: 50px;\n        z-index: 1;\n\n        &-subtitle {\n            display: flex;\n            font-size: 13px;\n            font-weight: 600;\n            color: #133A9A;\n            border-radius: 20px;\n            background-color: #E3EAFD;\n            border: 1px solid #cbdcfd;\n            padding: 7px 16px;\n            align-items: center;\n            gap: 8px;\n            letter-spacing: 0.5px;\n        }\n\n        &-container {\n            border: 1.5px solid #DEE0E3;\n            box-shadow: 0px 8px 30px rgba(71, 120, 245, 0.08), 0px 2px 8px rgba(0, 0, 0, 0.04);\n            border-radius: 24px;\n            width: 70vw;\n            padding: 14px;\n            gap: 16px;\n            display: flex;\n            flex-direction: column;\n            background: #ffffff;\n            transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n            &:focus-within {\n                border-color: #4778F5;\n                box-shadow: 0px 10px 36px rgba(71, 120, 245, 0.16), 0 0 0 3px rgba(71, 120, 245, 0.12);\n            }\n\n            &-dropdown {\n                border: 1px solid var(--border-action-normal, #DEE0E3);\n                box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);\n                padding: 10px;\n                border-radius: 14px;\n                display: flex;\n                flex-direction: column;\n                position: absolute;\n                z-index: 999;\n                background-color: white;\n                cursor: pointer;\n                min-width: 85%;\n                width: 150px;\n                top: 48px;\n                animation: fadeSlideIn 0.15s ease;\n\n                &-item {\n                    color: #14151A;\n                    font-size: 14px;\n                    font-weight: 400;\n                    padding: 8px 10px;\n                    border-radius: 6px;\n                    transition: background-color 0.15s ease;\n\n                    &:hover {\n                        background-color: #F0F5FF;\n                        color: #4778F5;\n                        font-weight: 500;\n                    }\n                }\n            }\n\n            &-field {\n                position: relative;\n                display: flex;\n                gap: 10px;\n                align-items: center;\n                width: 80%;\n\n                .keyboard-shortcut-hint {\n                    display: flex;\n                    align-items: center;\n                    position: absolute;\n                    right: 14px;\n                    pointer-events: none;\n\n                    kbd {\n                        background: #f1f5f9;\n                        border: 1px solid #cbd5e1;\n                        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n                        border-radius: 4px;\n                        padding: 2px 6px;\n                        font-size: 11px;\n                        font-family: inherit;\n                        font-weight: 600;\n                        color: #64748b;\n                    }\n                }\n\n                & input {\n                    background-color: transparent !important;\n                    border: none !important;\n                }\n\n                &-act {\n                    width: 77%;\n                    padding: 10px;\n                    display: flex;\n                    gap: 20px;\n\n                    &-title {\n                        box-shadow: 0px 1px 2px 0px #14151A0D;\n                        border: 1px solid var(--border-action-normal, #DEE0E3);\n                        padding: 7px;\n                        width: 70%;\n                        border-radius: 14px;\n\n                        & input {\n                            background-color: transparent !important;\n                            border: none !important;\n                        }\n                    }\n\n                    &-provision {\n                        box-shadow: 0px 1px 2px 0px #14151A0D;\n                        border: 1px solid var(--border-action-normal, #DEE0E3);\n                        padding: 7px;\n                        width: 30%;\n                        border-radius: 14px;\n\n                        & input {\n                            background-color: transparent !important;\n                            border: none !important;\n                        }\n                    }\n                }\n\n                &-button {\n                    background: linear-gradient(135deg, #4778F5 0%, #2563EB 100%);\n                    box-shadow: 0px 4px 12px rgba(71, 120, 245, 0.3);\n                    color: white;\n                    font-size: 14px;\n                    font-weight: 600;\n                    padding: 10px 24px;\n                    border-radius: 20px;\n                    cursor: pointer;\n                    border: 0px;\n                    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n\n                    &:hover {\n                        transform: translateY(-1px);\n                        box-shadow: 0px 6px 16px rgba(71, 120, 245, 0.4);\n                        background: linear-gradient(135deg, #3b6ef0 0%, #1d4ed8 100%);\n                    }\n\n                    &:active {\n                        transform: scale(0.98);\n                    }\n                }\n\n                &-bottom-container {\n                    display: flex;\n                    gap: 20px;\n                    align-items: center;\n                    justify-content: space-between;\n                }\n\n                & input {\n                    width: 90%;\n                    border: none;\n                    font-size: 16px;\n                    color: #14151A;\n                    background-color: transparent;\n                    border: none !important;\n\n                    &::placeholder {\n                        color: #0D112666;\n                        font-size: 16px;\n                        font-weight: 400;\n                    }\n\n                }\n\n            }\n\n            &-buttons {\n                display: flex;\n                flex-direction: row;\n                justify-content: space-between;\n                align-items: center;\n\n                &-right {\n                    border: 1px solid var(--border-action-normal, #DEE0E3);\n                    border-radius: 30px;\n                    box-shadow: 0px 1px 2px 0px #14151A0D;\n                    font-size: 14px;\n                    font-weight: 500;\n                    color: #14151A;\n                    padding: 10px 20px;\n                    display: flex;\n                    justify-content: space-between;\n                    min-width: 90px;\n                    cursor: pointer;\n                    gap: 10px;\n                    transition: background-color 0.15s ease;\n\n                    &:hover {\n                        background-color: #F8FAFC;\n                    }\n\n                    & input {\n                        border: none;\n                        border: none !important;\n                    }\n\n                }\n\n                &-left {\n                    display: flex;\n                    justify-content: space-between;\n                    gap: 16px;\n                    font-size: 16px;\n                    font-weight: 500;\n                    color: #14151A;\n\n                    &-tab {\n                        cursor: pointer;\n                        padding-bottom: 6px;\n                        color: #0F132499;\n                        font-size: 16px;\n                        font-weight: 500;\n                        transition: color 0.15s ease;\n\n                        &:hover {\n                            color: #4778F5;\n                        }\n                    }\n\n                    &-active {\n                        border-bottom: 2.5px solid #4778F5;\n                        color: #4778F5;\n                        font-size: 16px;\n                        font-weight: 600;\n                    }\n                }\n            }\n        }\n\n        &-description {\n            font-size: 18px;\n            font-weight: 500;\n            color: #475569;\n            max-width: 600px;\n            text-align: center;\n        }\n\n        &-title {\n            font-size: 48px;\n            font-weight: 800;\n            color: #0f172a;\n            text-align: center;\n            letter-spacing: -1px;\n\n            .title-gradient {\n                background: linear-gradient(135deg, #1d4ed8 0%, #4778f5 50%, #6366f1 100%);\n                -webkit-background-clip: text;\n                -webkit-text-fill-color: transparent;\n            }\n        }\n    }\n}\n\ninput {\n    &:focus {\n        border: none !important;\n        outline: none;\n    }\n}\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    line-height: 1.42857143;\n}\n\n@media (max-width: 1035px) {\n    #landing-page-lower-boxes {\n        display: grid !important;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 20px;\n    }\n    .landing-page-stats-bar {\n        gap: 16px;\n        padding: 12px 20px;\n\n        .stat-number {\n            font-size: 18px !important;\n        }\n    }\n}\n\n/* Mobile (1 column) */\n@media (max-width: 600px) {\n    #landing-page-lower-boxes {\n        display: grid !important;\n        grid-template-columns: 1fr;\n        gap: 16px;\n    }\n    .landing-page-lower-bottom-right {\n        display: grid !important;\n        grid-template-columns: 1fr;\n    }\n    .landing-page-upper-title {\n        font-size: 28px;\n    }\n    .landing-page-upper-description {\n        font-size: 15px;\n        text-align: center;\n    }\n    .landing-page-upper-container {\n        width: 90vw !important;\n    }\n    .landing-page-upper{\n        margin-top: 0px !important;\n    }\n    .landing-page-suggestions-dropdown {\n        width: 200px !important;\n    }\n    .landing-page-stats-bar {\n        flex-direction: column;\n        gap: 12px;\n        width: 90vw;\n\n        .landing-page-stat-divider {\n            width: 100%;\n            height: 1px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
